import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_909b0cd9-ab53-4cdb-baf5-2cde0d59c9a0/artifacts/fylrv7fv_horizontal%20Logos%20Full%20Color%20%282%29.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="gov-footer" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src={LOGO_URL} 
                alt="Canadian Document Services" 
                className="h-10 md:h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-white/70 text-sm mb-4 leading-relaxed">
              Canadian Document Services Inc.<br />
              Government Application Processing
            </p>
            <div className="space-y-2 text-white/60 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>5000 Yonge St. Suite 1901<br />North York, ON M2N 7E9<br />Canada</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>(866) 554-3535</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Services</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/record-suspensions" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-record-suspensions">
                Record Suspension
              </Link>
              <Link to="/us-entry-waivers" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-us-entry-waivers">
                U.S. Entry Waivers
              </Link>
              <Link to="/international-filings" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-international-filings">
                International Filings
              </Link>
            </nav>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Company</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/eligibility" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-eligibility">
                Eligibility Assessment
              </Link>
              <Link to="/contact" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-contact">
                Contact
              </Link>
              <Link to="/terms" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-terms">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="text-white/70 hover:text-white text-sm transition-colors" data-testid="footer-privacy">
                Privacy Policy
              </Link>
            </nav>
          </div>
        </div>

        {/* Divider */}
        <div className="gov-footer-divider" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p className="text-white/60">
            &copy; {currentYear} Canadian Document Services Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="text-white/60 hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <span className="text-white/30">|</span>
            <Link to="/privacy" className="text-white/60 hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
